import React, { useState, useRef, useEffect } from 'react';
import { API_BASE } from '../config';
import SettingsModal from './SettingsModal';
import Analytics from './Analytics';
import BugReport from './BugReport';

export default function TopBar({ channels, pinnedChannels, campaignNotes, plan }) {
  const isStandalone = !!localStorage.getItem('active_room');

  const handleUpgrade = (targetPlan) => {
    if (isStandalone) {
      const session = localStorage.getItem('session');
      if (!session) return;
      fetch('https://6uqbiwvsfh.execute-api.us-east-1.amazonaws.com/prod/billing/checkout', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + session, 'Content-Type': 'application/json' },
        body: JSON.stringify({ plan: targetPlan })
      }).then(r => r.json()).then(data => { if (data.url || data.checkout_url) window.location.href = data.url || data.checkout_url; });
    } else {
      window.location.href = `https://6uqbiwvsfh.execute-api.us-east-1.amazonaws.com/prod/auth/login?upgrade=true&plan=${targetPlan}`;
    }
  };
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [showBugReport, setShowBugReport] = useState(false);
  const menuRef = useRef(null);
  const session = localStorage.getItem('session');
  let user = null;
  if (session) {
    try {
      const payload = session.split('.')[1];
      const padding = 4 - payload.length % 4;
      const padded = padding !== 4 ? payload + '='.repeat(padding) : payload;
      user = JSON.parse(atob(padded));
    } catch (e) {}
  }

  const login = () => {
    window.location.href = 'https://6uqbiwvsfh.execute-api.us-east-1.amazonaws.com/prod/auth/login';
  };

  const logout = () => {
    localStorage.removeItem('session');
    window.location.reload();
  };

  const managePlan = async () => {
    const resp = await fetch('https://6uqbiwvsfh.execute-api.us-east-1.amazonaws.com/prod/billing/portal', { method: 'POST', headers: { 'Authorization': 'Bearer ' + session } });
    const data = await resp.json();
    if (data.portal_url) window.location.href = data.portal_url;
    else alert('No active subscription to manage.');
  };

  // Close menu on outside click
  useEffect(() => {
    const handler = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="top-bar">
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {user ? (
          <>
            <div className="user-menu-container" ref={menuRef}>
            <button className="user-menu-trigger" onClick={() => setMenuOpen(!menuOpen)}>
              <span className="gear-icon">⚙️</span>
            </button>
            {menuOpen && (
              <div className="user-menu-dropdown">
                <div className="menu-header">👤 {user.username}</div>
                <div style={{ padding: '0 12px 6px', fontSize: '0.55rem', color: 'var(--text-dim)', letterSpacing: '1px' }}>LWP v1.0</div>
                <div className="menu-divider"></div>
                <div className="menu-item" onClick={() => { setMenuOpen(false); setShowSettings(true); }}>⚙️ Settings</div>
                <div className="menu-item" onClick={() => { setMenuOpen(false); setShowAnalytics(true); }}>📈 Analytics</div>
                <div className="menu-item" onClick={() => { setMenuOpen(false); window.open('/about', '_blank'); }}>👤 About</div>
                <div className="menu-item" onClick={() => { setMenuOpen(false); setShowBugReport(true); }}>🪲 Report a Bug</div>
                <div className="menu-item" onClick={() => { setMenuOpen(false); managePlan(); }}>💳 Manage Subscription</div>
                <div className="menu-divider"></div>
                {isStandalone && <div className="menu-item menu-item-danger" onClick={() => { if (window.confirm('Leave this room? You can rejoin with the invite code.')) { fetch(`${API_BASE}/room/leave`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('session') }, body: JSON.stringify({ room_id: localStorage.getItem('active_room') }) }).then(r => r.json()).then(d => { if (d.ok) { localStorage.removeItem('active_room'); window.location.href = '/rooms'; } else { alert(d.error); } }); } }}>🚪 Leave Room</div>}
                <div className="menu-item menu-item-danger" onClick={logout}>🚪 Logout</div>
              </div>
            )}
          </div>
          </>
        ) : (
          <button onClick={login} style={{ background: '#5865F2', border: 'none', color: 'white', padding: '6px 14px', borderRadius: '6px', cursor: 'pointer', fontSize: '0.75rem' }}>
            Login with Discord
          </button>
        )}
      </div>
      <div className="title-container">
        <span className="title">🧙‍♂️ {'Lorewalker\'s  Panopticon'.split('').map((ch, i) => <span key={i} style={{ animationDelay: `${i*0.15}s` }}>{ch === ' ' ? '\u00A0' : ch}</span>)}</span>
      </div>
      {window._roomInviteCode && <div className="invite-code-display" title="Share this code to invite players">🔗 {window._roomInviteCode}</div>}
      <div ref={el => {
        if (el && plan === 'pro_plus' && !el._particleInterval) {
          el._particleInterval = setInterval(() => {
            const p = document.createElement('span');
            p.className = 'plan-particle';
            p.style.left = Math.random() * 100 + '%';
            p.style.setProperty('--dy', -(10 + Math.random() * 15) + 'px');
            el.appendChild(p);
            setTimeout(() => p.remove(), 1200);
          }, 200);
        }
      }} onClick={() => { if (plan === 'pro_plus') return; handleUpgrade(plan === 'pro' || plan === 'paid' ? 'pro_plus' : 'pro'); }} className={`plan-badge ${plan === 'pro_plus' ? 'badge-pro-plus' : plan === 'pro' || plan === 'paid' ? 'badge-pro' : 'badge-free'}`}>
        {plan === 'pro_plus' ? '✦ LOREWALKER' : plan === 'pro' || plan === 'paid' ? '⚔ STEWARD' : 'FREE ↑'}
      </div>
      {showSettings && <SettingsModal onClose={() => setShowSettings(false)} channels={channels} pinnedChannels={pinnedChannels} campaignNotes={campaignNotes} />}
      {showAnalytics && <Analytics onClose={() => setShowAnalytics(false)} />}
      {showBugReport && <BugReport onClose={() => setShowBugReport(false)} />}
    </div>
  );
}
